import { useEffect } from "react";
import dooctiFavicon from "../assets/images/Dooctilogo.svg";

import gtawkFavicon from "../assets/images/gtawk.png";
import skyfallFavicon from "../assets/images/SKyfalllogo.png";


const FaviconUpdater = () => {
  useEffect(() => {
    const baseURL = window.location.hostname;
    let favicon = dooctiFavicon;
    let faviconFileName = "favicon-default.ico";

    if (baseURL.includes("doocti.com")) {
      favicon = dooctiFavicon;
      faviconFileName = "favicon-doocti.ico";
    } else if (baseURL.includes("gtawk.com")) {
      favicon = gtawkFavicon;
      faviconFileName = "favicon-gtawk.ico";
    } else if (baseURL.includes("skyfalltech.in")) {
      favicon = skyfallFavicon;
      faviconFileName = "favicon-skyfall.ico";
    } else if (baseURL.includes("localhost")) {
      favicon = skyfallFavicon;
      faviconFileName = "favicon-skyfall.ico";
    }

    console.log(`Setting favicon: ${faviconFileName}`);

    const link =
      document.querySelector("link[rel~='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = favicon;
    document.head.appendChild(link);
  }, []);

  return null; // This component does not render anything
};

export default FaviconUpdater;
